export default __webpack_public_path__ + "static/media/vip-btn.143afe98.svg";